/**
 * @generated SignedSource<<e25f21034f4e0dff4a1b81961e1d6050>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BalanceManagement = "POSTPAID" | "PREPAID";
export type Segment = "business" | "personal" | "sparkdigitalshop";
export type AccountSelectorModalQuery$variables = {};
export type AccountSelectorModalQuery$data = {
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly accountNumber: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly balanceManagement: BalanceManagement | null;
      readonly customerSegment: string;
      readonly segment: Segment;
    }>;
  };
};
export type AccountSelectorModalQuery = {
  variables: AccountSelectorModalQuery$variables;
  response: AccountSelectorModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountList",
        "kind": "LinkedField",
        "name": "accountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "balanceManagement",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSegment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "segment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSelectorModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountSelectorModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a351cb12d41c311ab9f799452a46064f",
    "id": null,
    "metadata": {},
    "name": "AccountSelectorModalQuery",
    "operationKind": "query",
    "text": "query AccountSelectorModalQuery {\n  me {\n    accountList {\n      accountId\n      accountNumber\n      firstName\n      lastName\n      balanceManagement\n      customerSegment\n      segment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37a722e1d1f5a368b656d65f2ffba9da";

export default node;
